<template>
  <div class="discussion_young">
    <PageHeader
    :hero="require('../assets/discussion_young/hero.jpg')" 
    title="AI・データサイエンス領域 × 若手社員" 
    :image="require('../assets/discussion_young/title.svg')" 
    :imageSp="require('../assets/discussion_young/title_sp.svg')" 
    alt="Cross talk 1" 
    intro="入社2〜4年目の若手社員による、クロストークをお送りします。<br>
                若くして、AI・データサイエンス領域のプロジェクトにアサインされた3名は、<br>
                何を学び、どのような価値を創出しているのでしょうか。<br>
                一人ひとりの想いとともに、余すことなく語ってくれました。" 
    >
      <div class="people-wrap">
        <PeopleProfile
        color="orange" 
        :image="require('../assets/discussion_young/kazunari.jpg')" 
        alt="kazunari" 
        background="
            Kazunari<br>
            デジタル戦略支援事業部<br>
            第1グループ<br>
            博士(理学) コンサルタント<br>
            データサイエンティスト<br>
            29歳 入社2年目 博士課程修了" 
        profile="博士課程での専攻は惑星大気物理学。火星の大気環境を、NASA火星探査機のプラズマ観測データから明らかにする研究に専念。" 
        />
        <PeopleProfile
        color="blue" 
        :image="require('../assets/discussion_young/shunsuke.jpg')" 
        alt="Shunsuke" 
        background="
            Shunsuke<br>
            デジタル戦略支援事業部<br>
            第2グループ<br>
            AIスペシャリスト<br>
            27歳 入社4年目 修士課程修了" 
        profile="修士課程での専攻は純粋数学。純粋数学は、コンピュータなどのツールを使わずに、紙と鉛筆で研究を進める分野。" 
        />
        <PeopleProfile
        color="pink" 
        :image="require('../assets/discussion_young/yousuke.jpg')" 
        alt="Yousuke" 
        background="
            Yousuke<br>
            デジタル戦略支援事業部<br>
            第3グループ<br>
            コンサルタント<br>
            26歳 入社5年目 学部卒" 
        profile="学部での専攻は経済学。特にプログラミングなどの経験は無く、未経験で入社。" 
        />
      </div>
    </PageHeader>
    <DiscussionArticle
    :image="require('../assets/discussion_young/back01.jpg')" 
    :imageSp="require('../assets/discussion_young/back01_sp.jpg')" 
    title="豆蔵への入社理由" 
    name="Kazunari" 
    comment="「データサイエンティストと<br>
              ITコンサルタントの仕事が両立できるから」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-orange">
              Kazunari
            </span>
            大学では惑星大気物理学を専攻して、理学博士を取得しました。NASAのプロジェクトに参加し、データ分析技術を用いた火星大気の研究を行っていたので、そのスキルを活かせる会社を探していたところ、出会ったのが豆蔵です。<i>他社と異なったのは、データサイエンスに関わりながら、社内に閉じずにITコンサルティングの仕事も担当できること。</i>実際に入社してその通りだったので、良かったですね。Shunsukeさんは、どうして豆蔵に入ったのですか？
          </p>
          <p>
            <span class="name name-blue">   
              Shunsuke
            </span>
            私は、データサイエンス領域ではなく、数学を専攻して修士課程を修了しました。「純粋数学」が専門分野です。コンピュータを用いて大量の演算を繰り返す「応用数学」とは異なり、研究者の思考の中で新しい原理を追究する学問です。就職活動時の志望業界は、IT業界と金融業界でした。数学の知識や思考法を活用して、新しい何かを生み出す仕事に就きたいと思ったからです。<i>幾つかの会社の中で、先端のAI技術の開発に携われそうだと感じて豆蔵に入社しました。</i>
          </p>
          <p>
            <span class="name name-pink">
              Yousuke
            </span>
            3人の中で、私だけは文系出身で、経済学部を卒業しました。就職を考えるにあたって、金融業で直接的に経済活動に触れるよりは、ITの力で多くの会社を効率化して生産性を高めた方が、この国にとっては良いことだと考えていました。IT関連の職種の中でも、クライアント企業に入り込み、その変革をリードできるコンサルタント職に憧れていましたね。多くの会社を受けましたが、<i>会社の雰囲気が自分の「素」に近いと思ったので、豆蔵を選びました。</i>
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_young/image01.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image01_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_young/back02.jpg')" 
    :imageSp="require('../assets/discussion_young/back02_sp.jpg')" 
    title="現在携わっているプロジェクト" 
    name="Shunsuke" 
    comment="「自然言語処理を用いたチャットボットを、<br>
              一人で全て開発していました」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-orange">
              Kazunari
            </span>
            私が所属している「デジタル戦略支援事業部 第1グループ」は、<i>主に機械学習やデータサイエンスの技術を活用したプロジェクトを、クライアントとともに推進するグループです。</i>私自身は、入社して1年半になりますが、ある金融機関のプロジェクトを推進しています。テーマは、預金の「使用予測モデル」の開発です。その金融機関の利用者が、どれくらいのお金を引き出すのか、もしくは預けるのか、その量を予測することで、社内の保有金額を最適化できます。今は、マイナス金利が設定されているので、社内で保有している現金が多ければ多いほど、利子を取られてしまう。逆に、少なすぎると、巨額な融資に対応することが難しくなってしまう。その最適なバランスを、利用者の履歴データから導き出すプロジェクトです。<i>度重なる改善の末、私が開発したモデルの正確さを評価いただき、採用されることが決まりました。</i>Shunsukeさん、第2グループでは、どのようなプロジェクトに携わっていますか？
          </p>
          <p>
            <span class="name name-blue">
              Shunsuke
            </span>
            そうですね。私が籍を置いている第2グループは、コンサルティングを主業務とする1グループに比べて、より実装寄りのフェーズを担っています。<i>機械学習やIoTといった要素技術を用いて、ゼロからイチを生み出せることを強みと置いています。</i>私自身がメインで開発しているのは、対話型AIを用いたチャットボットである『MZbot™️』です。<i>豆蔵の自社プロダクトで、ここ1年くらいは私一人で開発を担当していました。</i>FAQをベースにスピーディに、簡単に導入できる独自性を持っているので、多くのクライアントから支持をいただいています。私のメイン・ミッションは、自然言語処理のロジックを、オープンソースを活用しながら強化していくこと。ただし、社内の環境に閉じて開発するのではなく、ユーザーのニーズに向き合うことも大切にしています。そのニーズをもとに新たな機能開発を行ったり、ユーザー側のデータを組込んで、個社ごとに機能をカスタマイズすることもありますね。Yousukeさんが所属している第3グループは、新しい部署ですよね？
          </p>
          <p>
            <span class="name name-pink">
              Yousuke
            </span>
            そうです。旬なサービスである<i>RPA（ロボティック・プロセス・オートメーション：ソフトウェア型のロボットが業務を代行・自動化するサービス）を活用したコンサルティングが、グループのメイン・ミッションです。</i>RPAの市場は、今まさに急速に拡大しています。しかし、RPAを導入している企業は多いのですが、その全ての企業が良い成果を挙げられているわけではありません。そのような企業に対して、きちんと業務効率化に結びつける支援をするのが、私自身の仕事です。クライアントが目指している「業務が効率化された姿」を、お互いに鮮明にイメージしながら、現場に最適な活用方法をクライアントとともにつくり、形にして、運用に乗せていく。その一連の流れを担当しています。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_young/image02.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image02_sp.jpg" alt="" class="under_display">
          <img src="../assets/discussion_young/image03.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image03_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_young/back03.jpg')" 
    :imageSp="require('../assets/discussion_young/back03_sp.jpg')" 
    title="仕事のやりがい" 
    name="Kazunari" 
    comment="「火星の大気データと、<br>
              金融機関の利用者のデータ。根本は同じです」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-orange">
              Kazunari
            </span>
            博士課程時代からデータを扱うのが好きでしたので、金融機関の大規模データに直接触れられるのは楽しいですね。扱っているデータが、学生時代と同じ「時系列データ」ということもあり、すんなり業務に入っていけました。時系列データとは、時間の推移とともに連続的に取得されるデータのこと。<i>火星の大気の状況も、金融機関のデータも、時間とともに変化するので、根本的な構造は同じなのです。</i>「いつ雨が降ったか」「その影響で何が起こったのか」「曜日によって異なる傾向は何か」といったものが該当します。これらのデータを可視化して傾向を見出し、その結果を元にクライアントとフラットに議論を行うのは、やりがいの一つですね。密に情報を共有しているので、クライアントの業務自体が進化している実感を持てています。
          </p>
          <p>
            <span class="name name-blue">
              Shunsuke
            </span>
            私は、Kazunariさんのコンサルタントとしての立ち位置とは少し異なり、新しいサービス開発に全力投球できることをやりがいに感じています。その一つの例として、<i>『MZbot™️』の英語版と中国版をリリースした</i>ことが挙げられます。開発においては、それぞれの自然言語処理のロジックを、まずはオープンソースになっているものから取り入れました。私自身は、英語も中国語を話すことはできませんが、色々な人に協力してもらうことで、何とか形にできました。クライアントからも好評をいただいていて嬉しいですね。Yousukeさんはどうですか？
          </p>
          <p>
            <span class="name name-pink">
              Yousuke
            </span>
            私は、クライアントとの接点において、仕事のやりがいを感じるタイプだと思います。仮に、直接会うのが難しいクライアントでしたら、別の手段で濃いコミュニケーションを取りながら、業務の改善を徹底的に支援しています。たとえば、九州のクライアントのRPAのシナリオづくりを支援したときは、メールやSkypeでの会議をかなりの回数で行いしました。そのクライアントに<i>「Yousukeさんのお陰で業務が楽になりました。数百時間の作業が効率化されて感謝しています」</i>とお礼を言われたときは、嬉しかったですね。テクノロジーの導入がゴールではなく、使ってもらって効果を上げて、初めて意味があるものだと改めて感じました。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_young/image04.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image04_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_young/back04.jpg')" 
    :imageSp="require('../assets/discussion_young/back04_sp.jpg')" 
    title="豆蔵のいいところと、入社後の成長" 
    name="Yousuke" 
    comment="「文系出身の自分が、入社3年で、<br>
              4つの開発言語をマスターできた」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-orange">
              Kazunari
            </span>
            豆蔵に入社後、<i>携わったプロジェクトは全て最先端技術に関するもの</i>です。これらのプロジェクトを、思い切りよく任せてくれるのが、豆蔵のいいところだと思います。入社直後のことですが、データベースの基礎知識であるSQLも全く分からない中、大手電機メーカーのプロジェクトにアサインされました。そこで、分析ツールのTableauを勉強しながらデータを可視化。クライアントに高い評価をいただき、<i>4か月後にそのメーカーの新製品の発売に立ち会うことができました。</i>知識が全く無かったSQLも、並行して学習して使っているとマスターできましたね。会社が大きな機会を意図的に与えてくれるので、この1年半で加速度的に成長できたと思っています。
          </p>
          <p>
            <span class="name name-blue">
              Shunsuke
            </span>
            同僚と仕事をしていて空気が重くなったことはありませんし、先輩・後輩関係なく、何かあればフラットに相談ができるのが良いですね。社内には様々なエキスパートが在籍しているので、分からないことがあれば、すぐに何でも聞けるのはありがたいです。一方で、間違った意見に対しては、きちんと指摘もしてくださいます。特に「ユーザー目線」についてインプットをもらえることが多く、<i>独りよがりのエンジニアだった入社当時からは、開発に対する考え方が大きく変わりましたね。</i>
          </p>
          <p>
            <span class="name name-pink">
              Yousuke
            </span>
            Shunsukeさんの言うとおりで、社内には頼れる人が多いです。自分はまだ5年目で、何かに悩んだ時に、<i>先輩や他の部署の方に相談すると、必ず「こうしたらいいよ」という心強いアドバイスをもらえます。</i>私は、このクロストークに参加した中で、唯一の文系出身者です。ITに関する知識がゼロの状態からスタートしました。しかし、豆蔵に入社してからは、<i>周囲から良質なインプットをいただくことで、4つの開発言語をマスターできました。</i>「クライアントの事業を変革できる、ITコンサルタントになりたい」という目標には、着実に近づいています。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_young/image05.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image05_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
    <DiscussionArticle
    :image="require('../assets/discussion_young/back05.jpg')" 
    :imageSp="require('../assets/discussion_young/back05_sp.jpg')" 
    title="将来の目標" 
    name="Shunsuke" 
    comment="「全ての業務用PCに、『MZbot™️』が<br>
              インストールされている世界をつくりたい」" 
    >
      <div class="article-body">
        <div class="text">
          <p>
            <span class="name name-orange">
              Kazunari
            </span>
            技術面では、AIをもっと勉強したいですね。まずは、ディープラーニングのアルゴリズムを自分で組めるようになることが目標です。あらゆる最新技術に精通した上で、自分でプロジェクトを提案して、自分で形にしていきたいですね。プロジェクトマネージャーになるだけではなく、プレイヤーとして技術に磨きを掛けていく。<i>上流〜下流まで全てを担えるコンサルタントになりたいです。</i>
          </p>
          <p>
            <span class="name name-blue">
              Shunsuke
            </span>
            <i>全ての業務用PCに、『MZbot™️』がインストールされている世界</i>をつくりたいですね。そのためには、もっともっとユーザーの声を聞かなくてはなりません。今は、ユーザーとの接点が少ないので、技術スキルを磨くことで開発を効率化して、外部の方と接する時間をつくっていきたいですね。
          </p>
          <p>
            <span class="name name-pink">
              Yousuke
            </span>
            クライアントのより大きな業務変革を担うために、<i>技術スキルの幅を広げていきたいです。</i>ネットワーク系の技術やサーバー構築スキルは、まだまだ自分には足りていません。今の上司は、課題を先回りして捉えて、大きな絵を描いてクライアントとともに改革を実現できています。まずは、そこに近づきたいと思っています。
          </p>
        </div>
        <div class="image">
          <img src="../assets/discussion_young/image06.jpg" alt="" class="over_display">
          <img src="../assets/discussion_young/image06_sp.jpg" alt="" class="under_display">
        </div>
      </div>
    </DiscussionArticle>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/discussion/PageHeader.vue';
import PeopleProfile from '@/components/discussion/PeopleProfile.vue';
import DiscussionArticle from '@/components/discussion/DiscussionArticle.vue';
export default {
  name: 'discussion_young',
  components: {
    PageHeader,
    PeopleProfile,
    DiscussionArticle
  },
}
</script>

<style lang="scss" scoped>
.discussion_young {
  position: relative;
  margin-bottom: 50px;
}
.people-wrap {
  margin: 0 auto;
  justify-content: center;
  @media print, screen and (min-width: 1161px) {
    display: flex;
  }
}
.article-body {
  margin: 0 auto;
  max-width: 910px;
  width: 100%;
  justify-content: space-between;
  margin-top: 100px;
  @media print, screen and (min-width: 1161px) {
    display: flex;
  }
  @media print, screen and (max-width: 1160px) { 
    max-width: 90%;
  }
  .text {
    max-width: 560px;
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    @media print, screen and (max-width: 1160px) { 
      max-width: 90%;
      margin-bottom: 50px;
    }
    .name {
      display: block;
      &.name-orange {
        color: #ff6b00;
      }
      &.name-blue {
        color: #2e8fff;
      }
      &.name-pink {
        color: #ff6080;
      }
    }
    p {
      font-size: 12px;
    }
    i {
      font-style: normal;
      background: linear-gradient(transparent 50%, #ffcf82 50%); 
    }
  }
  .image {
    width: 100%;
    margin: 0 auto;
    @media print, screen and (min-width: 1161px) {
      max-width: 260px;
    }
    @media print, screen and (max-width: 1160px) {
      max-width: 500px;
    }
    img {
      margin-bottom: 50px;
      @media print, screen and (max-width: 1160px) {
        margin-bottom: 30px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
